// extracted by mini-css-extract-plugin
export default {"search-results":"Popper_search-results__WWLrS"};